import {gsap} from "gsap";
import {ElementLinkUnderlineItem} from "../element-link-underline/element-link-underline-item";
import {MathMap} from "../../../libs/math-utils";
import {checkDeviceMobile} from "../../../libs/helper";

export class ButtonItem {
    constructor({el}) {
        this.DOM = {el};

        this.DOM.el.classList.add('is-handler');
        this.line = new ElementLinkUnderlineItem({el: this.DOM.el.querySelector('.js-estButton_text'), isEvent: false});

        this.svg1 = {value: 0};
        this.svg2 = {value: 0};

        this.DOM.icon = this.DOM.el.querySelector('.js-estButton_icon');

        this.DOM.svg1 = this.DOM.icon.querySelector('svg');
        this.DOM.svg2 = this.DOM.svg1.cloneNode(true);

        this.svg1Paths = this.DOM.svg1.querySelectorAll('path');
        this.svg2Paths = this.DOM.svg2.querySelectorAll('path');

        this.svg1Paths[0].style.strokeDashoffset = 0;
        this.svg2Paths[0].style.strokeDashoffset = 41;

        this.svg1Paths[1].style.strokeDashoffset = 0;
        this.svg2Paths[1].style.strokeDashoffset = 20;

        this.DOM.icon.append(this.DOM.svg2);

        this.bindEvent();
    }


    mouseEnter() {
        this.line.onHover();

        gsap.killTweensOf([this.svg1, this.svg2])

        gsap.fromTo(this.svg1, {value: 0}, {
            value: 100, duration: .8, ease: 'power3.out', onUpdate: () => {
                const svg1_path_1 = Math.min(MathMap(this.svg1.value, 0, 50, 0, 41), 41);
                this.svg1Paths[0].style.strokeDashoffset = svg1_path_1;

                const svg1_path_2 = Math.min(MathMap(this.svg1.value, 50, 100, 0, 20), 20);
                this.svg1Paths[1].style.strokeDashoffset = Math.max(Math.min(svg1_path_2, 20), 0);
            }
        });

        gsap.fromTo(this.svg2, {value: 0}, {
            value: 100, duration: .8, ease: 'power3.out', delay: .3, onUpdate: () => {
                const svg2_path_1 = Math.min(MathMap(this.svg2.value, 0, 50, 41, 82), 82);
                this.svg2Paths[0].style.strokeDashoffset = svg2_path_1;

                const svg2_path_2 = MathMap(this.svg2.value, 50, 100, 20, 40);
                this.svg2Paths[1].style.strokeDashoffset = Math.max(Math.min(svg2_path_2, 40), 20);
            }
        });
    }

    bindEvent() {
        if (!checkDeviceMobile()) {
            this.DOM.el.addEventListener('mouseenter', this.mouseEnter.bind(this));
        }
    }
}